import { api } from "../../../infra/api";
import { Paginate } from "../../../infra/paginate";
import { URLS } from "../../../infra/URLS";
import { Produto } from "../types/Produto";

export async function getProdutos(search?: string, page = 1) {
  const { data } = await api.get<Paginate<Produto>>(
    `${URLS.PRODUTOS_API}`, {
      params: {page, search}
    });

  return data;
}

export async function getProdutoModulo(ProdutoId: number): Promise<any | any> {
  const resultJson = await api
    .get(`${URLS.PRODUTOS_API}/${ProdutoId}`)
    .then((resp) => resp.data);

  return resultJson;
}

export async function getAllProdutos(search?: string) {
  const size = await api
    .get(`${URLS.PRODUTOS_API}`)
    .then((resp) => resp.data.meta);

  const resultJson = await api
    .get(
      `${URLS.PRODUTOS_API}?${search ? "search" : "limit"}=${
        search ? search : size.totalItems
      }`
    )
    .then((resp) => resp.data.items);
    
  return resultJson;
}
